import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";

import { formatAmountWithCurrency } from "./utils/currency";

/**
 * PaymentLinkDeleteModal – Ödeme linkini silme onayı.
 *
 * Silme geri alınamadığı ve linki ödemeye kapattığı için onay ister. Silinen
 * linkin tahsilat geçmişi backend'de korunur; bunu özet bloğunda gösteriyoruz
 * ki kullanıcı "ödemeleri de siliyor muyum?" tereddüdü yaşamasın.
 */
const PaymentLinkDeleteModal = ({ isOpen, toggle, link, onConfirm, loading = false }) => {
    // Sabit linkte backend sayacı, tek kullanımlıkta ödeme gerçekleştiyse linkin tutarı.
    const isFixed = link?.linkType === "FIXED";
    const paymentCount = isFixed ? (link?.paymentCount ?? 0) : (link?.userPaid ? 1 : 0);
    const collected = isFixed
        ? (link?.totalCollected ?? 0)
        : (link?.userPaid ? link?.fixedAmount ?? null : 0);

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} className="text-danger">
                <i className="bx bx-trash me-2" /> Ödeme Linkini Sil
            </ModalHeader>

            <ModalBody>
                <div className="text-center mb-3">
                    <i className="bx bx-error-circle display-4 text-danger d-block mb-2" />
                    <h5 className="mb-1">Bu link silinsin mi?</h5>
                    <p className="text-muted mb-0">
                        Link listeden kaldırılacak ve ödemeye kapanacak. Bu işlem{" "}
                        <strong>geri alınamaz</strong>. Link üzerinden alınmış{" "}
                        <strong>tahsilatlar ve ödeme geçmişi korunur</strong>.
                    </p>
                </div>

                {link && (
                    <div className="bg-light rounded-4 p-3">
                        <div className="d-flex justify-content-between gap-3 mb-2">
                            <span className="text-muted small">Şirket</span>
                            <span className="fw-semibold text-end">{link.companyName || "-"}</span>
                        </div>
                        <div className="d-flex justify-content-between gap-3 mb-2">
                            <span className="text-muted small">Cari / Bayi</span>
                            <span className="fw-semibold text-end">{link.accountName || "-"}</span>
                        </div>
                        <div className="d-flex justify-content-between gap-3 mb-2">
                            <span className="text-muted small">Link Tipi</span>
                            <span className="fw-semibold text-end">{isFixed ? "Sabit link" : "Tek kullanımlık"}</span>
                        </div>
                        <div className="d-flex justify-content-between gap-3">
                            <span className="text-muted small">Alınan Tahsilat</span>
                            <span className="fw-semibold text-end">
                                {paymentCount} ödeme
                                {collected != null && Number(collected) > 0
                                    ? ` · ${formatAmountWithCurrency(collected, link.currency)}`
                                    : ""}
                            </span>
                        </div>
                    </div>
                )}
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={loading}>Vazgeç</Button>
                <Button color="danger" onClick={onConfirm} disabled={loading}>
                    {loading ? <Spinner size="sm" className="me-1" /> : <i className="bx bx-trash me-1" />}
                    Evet, Sil
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PaymentLinkDeleteModal;
